import styled from 'styled-components';
import TextareaAutosize from 'react-autosize-textarea';

export const Wrapper = styled.div`
  padding: 10px;
  row-gap: 1px;
  column-gap: 6px;
  align-items: center;
  grid-template-columns: min-content 1fr min-content;
  display: grid;
`;

export const Question = styled(TextareaAutosize)`
  font-weight: 500;
  line-height: 20px;
`;

export const Description = styled(TextareaAutosize)`
  font-size: 14px;
  line-height: 20px;
`;

export const Controls = styled.div`
  grid-auto-flow: column;
  display: inline-grid;
`;

export const Container = styled.div`
  display: grid;
`;
